// Importing necessary React libraries and components
import React, { useState } from "react";
import { Tab, Tabs, Box } from "@mui/material";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { styled } from "@mui/material/styles";

// Importing custom components
import Events from "./Event";
import ScheduledEvents from "./ScheduledEvents";

// Importing styles
import "../../assets/css/Home.css";
import { useNavigate } from "react-router-dom";
import SimplePopper from "../CreateEvent/SimplePopper";

// Custom styled button
const ColorButton = styled((props) => <Button {...props} />)({
  color: "white",
  backgroundColor: "rgb(0,105,255)",
  "&:hover": {
    backgroundColor: "rgb(0,95,230)",
  },
  borderRadius: "30px",
  height: "50px",
});

// Main Home component
const Home = (props) => {
  // Tab value state
  const [value, setValue] = React.useState(0);

  // On component mount, set the tab value based on the URL query parameter
  React.useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryParam = searchParams.get("tab");
    if (queryParam) {
      const index = parseInt(queryParam);
      if (!isNaN(index) && index - 1 >= 0 && index - 1 < 2) {
        setValue(index - 1);
      }
    }
  }, []);

  // Function to handle tab changes
  const handleChange = (event, newValue) => {
    setValue(newValue);
    const searchParams = new URLSearchParams(window.location.search);
    if (newValue === 0) {
      searchParams.delete("scheduletab");
    } else if (newValue === 1) {
      searchParams.set("scheduletab", 1);
    }
    searchParams.set("tab", newValue + 1);
    const newUrl = window.location.pathname + "?" + searchParams.toString();
    window.history.pushState(null, null, newUrl);
  };

  // Function to create a tab panel
  function TabPanel(e) {
    const { children, value, index, ...other } = e;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {e.display}
      </div>
    );
  }

  // Function to assign ARIA roles for accessibility
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const navigate = useNavigate();
  // Render component
  return (
    <div>
      <div className="content-header">
        <div className="content-head">
          <div className="top">
            <div className="flex">
              <h2>My Timely</h2>
            </div>
            <div className="flex end">
              {" "}
              <SimplePopper
              text="You have reached your limit of events! Upgrade for more."
                anchorEl={anchorEl}
                handleAwayClick={() => {
                  setAnchorEl(null);
                }}
              />
              <ColorButton
                variant="contained"
                startIcon={<AddIcon />}
                onClick={(e) => {
                  props.data.length&&props.currentUser.role.toLowerCase()==="starter" ? handleClick(e) : navigate("/app/new");
                }}
                style={{ background: "#d9bca9" }}
              >
                {" "}
                Create
              </ColorButton>
            </div>
          </div>
          <div className="bot">
            <Box sx={{ width: "100%" }}>
              <Box>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Event Types" {...a11yProps(0)} />
                  <Tab label="Scheduled Events" {...a11yProps(1)} />
                </Tabs>
              </Box>
            </Box>
          </div>
        </div>
      </div>

      <TabPanel
        value={value}
        index={0}
        display={
          <Events
            refetch={props.refetch}
            user={props.currentUser.url}
            data={props.data}
          />
        }
      >
        Event Types
      </TabPanel>
      <TabPanel
        value={value}
        index={1}
        display={
          <ScheduledEvents data={props.data} currentUser={props.currentUser} />
        }
      >
        Scheduled Events
      </TabPanel>
    </div>
  );
};

// Export the component
export default Home;
